export default __webpack_public_path__ + "static/media/plexusstrike2.ca604baa.png";